import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { trackerSession, verifySession } from "@/tracker/lib/trackerApi";

const TrackerAuthContext = createContext(null);

export function TrackerAuthProvider({ children }) {
  const [session, setSession] = useState(() => trackerSession.get());
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const verify = async () => {
      const s = trackerSession.get();
      if (!s) {
        if (!cancelled) setChecking(false);
        return;
      }
      try {
        await verifySession();
        if (!cancelled) setSession(s);
      } catch {
        trackerSession.clear();
        if (!cancelled) setSession(null);
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    verify();
    return () => { cancelled = true; };
  }, []);

  const login = useCallback((s) => {
    trackerSession.set(s);
    setSession(s);
  }, []);

  const logout = useCallback(() => {
    trackerSession.clear();
    setSession(null);
  }, []);

  return (
    <TrackerAuthContext.Provider value={{ session, checking, login, logout }}>
      {children}
    </TrackerAuthContext.Provider>
  );
}

export function useTrackerAuth() {
  const ctx = useContext(TrackerAuthContext);
  if (!ctx) throw new Error("useTrackerAuth must be inside TrackerAuthProvider");
  return ctx;
}
